module.exports = __webpack_public_path__ + "img/arduino.103c1270.png";